import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Message = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.078.42H9.02A8.985 8.985 0 0 0 0 9.445v15.642a8.985 8.985 0 0 0 9.02 9.025h3.007c1.603 0 3.007 1.304 3.007 3.008v5.215c0 1.804 2.104 2.707 3.407 1.604l10.223-8.925c.2-.2.4-.3.701-.4.401-.201.802-.301 1.203-.301h2.506c5.211 0 9.621-3.71 10.724-8.624v-.2c.2-.703.2-1.505.2-2.307V9.445C44.098 4.43 40.09.42 35.078.42Zm-2.004 31.586h-2.506c-.701 0-1.503.2-2.105.502-.4.2-.801.4-1.202.702l-10.123 8.924V37.02c0-2.808-2.305-5.014-5.01-5.014H9.12c-3.808 0-6.915-3.108-6.915-6.919V9.445c0-3.81 3.107-6.92 6.915-6.92h26.058c3.809 0 6.916 3.11 6.916 6.92v13.637c0 .601-.1 1.203-.2 1.805-1.003 4.111-4.51 7.12-8.82 7.12Z"
  }));
});
Message.displayName = 'Message';
Message.defaultProps = {
  'aria-label': 'Message'
};
export default Message;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Message.js
// module id = 3837
// module chunks = 11